var getDefaultIconPropValues = function getDefaultIconPropValues(iconProp, defaultSize) {
  return {
    component: iconProp ? iconProp.component : undefined,
    size: iconProp && typeof iconProp.size === 'number' ? iconProp.size : defaultSize || 24,
    hasFill: iconProp && typeof iconProp.hasFill === 'boolean' ? iconProp.hasFill : true,
    hasStroke: iconProp && typeof iconProp.hasStroke === 'boolean' ? iconProp.hasStroke : false
  };
};
export default getDefaultIconPropValues;